import Vue from 'vue';
import Vuex from 'vuex';
import * as axios from 'axios';
import * as login from './modules/login';
import * as pacientModule from './modules/pacient';
import * as pacientiModule from './modules/pacienti';
import * as reviews from './modules/reviews';
import * as sterilizare from './modules/sterilizare';
import calendar from './modules/calendar';
import statistics from './modules/statistics';
import note from './modules/note';
// import { state } from './state';
// import { getters } from './getters';
// import { mutations } from './mutations';
// import { actions } from './actions';
import router from '../router';
import { checkObjProps } from './utils';
import { api } from './api';
import { svg } from './svg'
// import { nextDate } from './utils'
import { judete } from './judete'
import * as _ from 'lodash'
import { STRINGS } from './strings'
import { isEqualString } from './utils'

axios.defaults.withCredentials = true;

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: {},
    pacient: {
      history: [],
      _attachments: {},
      varsta: '',
      icalendar: [],
      send_feedback_after_treatment: false,
      feedback_after_treatment_sent_at: null,
      feedback_lang: 'RO'
    },
    blockPacient: Boolean,
    searchResultsPerPage: 10,
    searchPagination: false,
    pacientiSearchResults: [],
    isSemnaturaActiva: false,
    filter: {
      isFilterPatients: false,
      payload: {},
      bookmarks: []
    },
    isExistingUser: false,
    svg,
    roluri: [
      'medic',
      'asistent',
      'admin'
    ],
    isClickModal: false,
    isLoading: false,
    isUpdateModal: false,
    modalData: {
      type: undefined,
      createdAt: new Date(),
      pics: []
    },
    modalProgramare: {
      createdAt: new Date(new Date().setDate(new Date().getDate() + 1)),
      trimite_sms: true,
      deLa: { ora: '', minute: '' },
      panaLa: { ora: '', minute: '' }
    },
    formData: new FormData(),
    modelTratament: {
      type: 'tratament',
      createdAt: new Date(),
      dinte: undefined,
      denumire: undefined,
      detalii: undefined
    },
    isLogged: false,
    isEditPacient: false,
    orase: [],
    judete: [],
    tari: [
      'Afghanistan',
      'Albania',
      'Algeria',
      'Andorra',
      'Angola',
      'Antigua and Barbuda',
      'Argentina',
      'Armenia',
      'Australia',
      'Austria',
      'Azerbaijan',
      'The Bahamas',
      'Bahrain',
      'Bangladesh',
      'Barbados',
      'Belarus',
      'Belgium',
      'Belize',
      'Benin',
      'Bhutan',
      'Bolivia',
      'Bosnia and Herzegovina',
      'Botswana',
      'Brazil',
      'Brunei',
      'Bulgaria',
      'Burkina Faso',
      'Burundi',
      'Cabo Verde',
      'Cambodia',
      'Cameroon',
      'Canada',
      'Central African Republic',
      'Chad',
      'Chile',
      'China',
      'Colombia',
      'Comoros',
      'Congo, Democratic Republic of the',
      'Congo, Republic of the',
      'Costa Rica',
      'Côte d’Ivoire',
      'Croatia',
      'Cuba',
      'Cyprus',
      'Czech Republic',
      'Denmark',
      'Djibouti',
      'Dominica',
      'Dominican Republic',
      'East Timor (Timor-Leste)',
      'Ecuador',
      'Egypt',
      'El Salvador',
      'Equatorial Guinea',
      'Eritrea',
      'Estonia',
      'Eswatini',
      'Ethiopia',
      'Fiji',
      'Finland',
      'France',
      'Gabon',
      'The Gambia',
      'Georgia',
      'Germany',
      'Ghana',
      'Greece',
      'Grenada',
      'Guatemala',
      'Guinea',
      'Guinea-Bissau',
      'Guyana',
      'Haiti',
      'Honduras',
      'Hungary',
      'Iceland',
      'India',
      'Indonesia',
      'Iran',
      'Iraq',
      'Ireland',
      'Israel',
      'Italy',
      'Jamaica',
      'Japan',
      'Jordan',
      'Kazakhstan',
      'Kenya',
      'Kiribati',
      'Korea, North',
      'Korea, South',
      'Kosovo',
      'Kuwait',
      'Kyrgyzstan',
      'Laos',
      'Latvia',
      'Lebanon',
      'Lesotho',
      'Liberia',
      'Libya',
      'Liechtenstein',
      'Lithuania',
      'Luxembourg',
      'Madagascar',
      'Malawi',
      'Malaysia',
      'Maldives',
      'Mali',
      'Malta',
      'Marshall Islands',
      'Mauritania',
      'Mauritius',
      'Mexico',
      'Micronesia, Federated States of',
      'Moldova',
      'Monaco',
      'Mongolia',
      'Montenegro',
      'Morocco',
      'Mozambique',
      'Myanmar (Burma)',
      'Namibia',
      'Nauru',
      'Nepal',
      'Netherlands',
      'New Zealand',
      'Nicaragua',
      'Niger',
      'Nigeria',
      'North Macedonia',
      'Norway',
      'Oman',
      'Pakistan',
      'Palau',
      'Panama',
      'Papua New Guinea',
      'Paraguay',
      'Peru',
      'Philippines',
      'Poland',
      'Portugal',
      'Qatar',
      'Romania',
      'Russia',
      'Rwanda',
      'Saint Kitts and Nevis',
      'Saint Lucia',
      'Saint Vincent and the Grenadines',
      'Samoa',
      'San Marino',
      'Sao Tome and Principe',
      'Saudi Arabia',
      'Senegal',
      'Serbia',
      'Seychelles',
      'Sierra Leone',
      'Singapore',
      'Slovakia',
      'Slovenia',
      'Solomon Islands',
      'Somalia',
      'South Africa',
      'Spain',
      'Sri Lanka',
      'Sudan',
      'Sudan, South',
      'Suriname',
      'Sweden',
      'Switzerland',
      'Syria',
      'Taiwan',
      'Tajikistan',
      'Tanzania',
      'Thailand',
      'Togo',
      'Tonga',
      'Trinidad and Tobago',
      'Tunisia',
      'Turkey',
      'Turkmenistan',
      'Tuvalu',
      'Uganda',
      'Ukraine',
      'United Arab Emirates',
      'United Kingdom',
      'United States',
      'Uruguay',
      'Uzbekistan',
      'Vanuatu',
      'Vatican City',
      'Venezuela',
      'Vietnam',
      'Yemen',
      'Zambia',
      'Zimbabwe'
    ],
    medici: [],
    tratamente: [
      {
        name: 'punte ceramică / Zirconiu',
        fill: '#34a186',
        dinteDD: true,
        id: 6.1
      },
      {
        name: 'punte acrilică provizorie',
        fill: '#a9e8e6',
        dinteDD: true,
        id: 6.4
      },
      {
        name: 'punte metalo-ceramică',
        fill: '#FFB400',
        dinteDD: true,
        id: 6.5
      },
      { name: 'consultatie primara' },
      { name: 'igienizare' },
      { name: 'consult specialitate' },
      { name: 'albire dentara' },
      { name: 'obturatie compozit / obturatie estetica', dinteDD: true },
      { name: 'tatuaj dentar / bijuterii dentare', dinteDD: true },
      { name: 'gutiera bruxism' },
      { name: 'obturatie compozit fotopolimerizabil', dinteDD: true },
      { name: 'obturatie glass-ionomer', dinteDD: true },
      { name: 'pansament calmant', dinteDD: true },
      { name: 'sigilare santuri si fosete', dinteDD: true },
      {
        name: 'coroana zirconiu pe implant',
        dinteDD: true,
        id: 1.1
      },
      {
        name: 'coroana ceramica pe schelet Zirconiu',
        dinteDD: true,
        id: 1.1
      },
      {
        name: 'fatete integral ceramice',
        color: '#4fcfb1',
        dinteDD: true,
        id: 1.2
      },
      {
        name: 'inlay onlay / CAD CAM',
        color: '#4fcfb1',
        dinteDD: true,
        id: 1.3
      },
      {
        name: 'coroana acrilica / coroana provizorie',
        color: '#a9e8e6',
        dinteDD: true,
        id: 1.4
      },
      {
        name: 'coroana metalo-ceramica pe implant',
        dinteDD: true,
        id: 1.5
      },
      {
        name: 'coroana metalo-ceramica',
        color: '#FFB400',
        dinteDD: true,
        id: 1.5
      },
      { name: 'dispozitiv corono radicular / DCR', dinteDD: true },
      { name: 'sistem protetic special / scheletata' },
      { name: 'sistem protetic special / Bredent, Ancorvis' },
      { name: 'proteza Kemeny / Maryland' },
      { name: 'mockup' },
      { name: 'ablatie coroana', dinteDD: true },
      { name: 'cimentare', dinteDD: true },
      { name: 'protocol DSD' },
      { name: 'terapie parodontala laser' },
      { name: 'recall parodontal laser' },
      { name: 'frenectomie / bridectomie' },
      { name: 'gingivectomie laser' },
      {
        name: 'extractie monoradiculari',
        dinteDD: true,
        id: 3
      },
      {
        name: 'extractie pluriradiculari',
        dinteDD: true,
        id: 3
      },
      {
        name: 'odontectomie',
        dinteDD: true,
        id: 3
      },
      { name: 'dinti temporari', dinteDD: true },
      { name: 'decapusonare laser', dinteDD: true },
      { name: 'drenaj abces parodontal / irigatii', dinteDD: true },
      { name: 'drenaj endodontic', dinteDD: true },
      { name: 'tratament pericoronarita laser', dinteDD: true },
      { name: 'rezectie apicala monoradiculari', dinteDD: true },
      { name: 'rezectie apicala premolari', dinteDD: true },
      { name: 'extractie molar 3 erupt (de minte)' },
      {
        name: 'implant ICX Templant',
        dinteDD: true,
        id: 4
      },
      { name: 'ghid chirurcical digital segmentar' },
      { name: 'ghid chirurgical digital arcada' },
      { name: 'bont protetic personalizat', dinteDD: true },
      { name: 'overdenture' },
      { name: 'accesorii implant', dinteDD: true },
      { name: 'indepartare chirurgicala implant', dinteDD: true },
      { name: 'tratament alveolita', dinteDD: true },
      { name: 'chistectomie' },
      { name: 'plastie comunicare oro-sinusala' },
      { name: 'inhalosedare' },
      { name: 'augmentare osoasa' },
      { name: 'sinuslift intern' },
      { name: 'sinuslift extern' },
      { name: 'RX retroalveolara' },
      { name: 'RX panoramica' },
      { name: 'CT partial' },
      { name: 'CT total' },
      { name: 'scanare' },
      { name: 'PRF' },
      {
        name: 'endodontie microscopica',
        dinteDD: true,
        id: 5.1
      },
      {
        name: 'pulpectomie + obturatie canal',
        dinteDD: true,
        id: 5.2
      },
      {
        name: 'retratament endodontic',
        dinteDD: true,
        id: 5.3
      },
      { name: 'dezobturare canal', dinteDD: true },
      { name: 'aplicare MTA', dinteDD: true },
      { name: 'ablatie / ace rupte / DCR' },
      { name: 'ablatie DCR', dinteDD: true },
      { name: 'contentie', dinteDD: true },
      { name: 'grefa gingivala' },
      { name: 'testare microbiologica (PET)' },
      { name: 'consultatie ortodontica / amprenta / plan' },
      { name: 'amprenta' },
      { name: 'inregistrare si montare in articulator' },
      { name: 'plan tratament' },
      { name: 'aparat mobilizabil' },
      { name: 'aparat functional' },
      { name: 'trainer' },
      { name: 'aparat ortodontic fix metalic' },
      { name: 'aparat ortodontic fix fizionomic' },
      { name: 'clear aligners' },
      { name: 'control + activare aparat mobilizabil' },
      { name: 'control + activare aparat fix' },
      { name: 'recolare bracket metalic', dinteDD: true },
      { name: 'recolare bracket fizionomic', dinteDD: true },
      { name: 'recimentare inel', dinteDD: true },
      { name: 'inlocuire inel', dinteDD: true },
      { name: 'reparatie aparat mobilizabil' },
      { name: 'indepartare aparat fix + igienizare (per arcada)' },
      { name: 'gutiera contentie' },
      { name: 'bite plate' },
      { name: 'disjunctor (activari incluse)' },
      { name: 'bara palatinala / linguala' },
      { name: 'buton nance' },
      { name: 'lip bumper' },
      { name: 'mini implant ortodontic (TAD)', dinteDD: true },
      { name: 'arc facial + headgear' },
      { name: 'contentie fixa' },
      { name: 'contentie mobilizabila' },
      { name: 'control contentie' },
      { name: 'mentinator de spatiu fix (cu ansa)' },
      { name: 'mentinator de spatiu mobilizabil (cu dinti)' },
      { name: 'tratamente icon' },
    ],
    ddClone: undefined,
    pacienti: [],
    utilizatori: [],
    pacientiClone: undefined,
    antecedente: false,
    alergii: false,
    modalComponentName: '',
    isModal: false,
    isEditHistory: false,
    page: 0,
    bookmarks: [],
    lastPage: false,
    numeDinte: undefined,
    dinteElm: undefined,
    defaults: {
      opacity: '0.1'
    },
    disableDintiDD: false,
    printComponentName: 'fisaPacient',
    // printComponentName: 'scrisoareMedicala',
    textScrisoare: '',
    isEditScrisoare: false,
    indexScrisoare: undefined,
    avatarPic: undefined,
    dinti: [
      'molar 1.8',
      'molar 1.7',
      'molar 1.6',
      'molar 2.6',
      'molar 2.7',
      'molar 2.8',
      'molar 4.8',
      'molar 4.7',
      'molar 4.6',
      'molar 3.6',
      'molar 3.7',
      'molar 3.8',
      'premolar 1.5',
      'premolar 1.4',
      'premolar 2.4',
      'premolar 2.5',
      'premolar 4.4',
      'premolar 4.5',
      'premolar 3.4',
      'premolar 3.5',
      'canin 1.3',
      'canin 2.3',
      'canin 4.3',
      'canin 3.3',
      'incisiv 1.2',
      'incisiv 1.1',
      'incisiv 2.1',
      'incisiv 2.2',
      'incisiv 4.2',
      'incisiv 4.1',
      'incisiv 3.1',
      'incisiv 3.2',
    ],
    dantura: {
      top: [
        'molar-1.8',
        'molar-1.7',
        'molar-1.6',
        'premolar-1.5',
        'premolar-1.4',
        'canin-1.3',
        'incisiv-1.2',
        'incisiv-1.1',
        'incisiv-2.1',
        'incisiv-2.2',
        'canin-2.3',
        'premolar-2.4',
        'premolar-2.5',
        'molar-2.6',
        'molar-2.7',
        'molar-2.8'
      ],
      bottom: [
        'molar-4.8',
        'molar-4.7',
        'molar-4.6',
        'premolar-4.5',
        'premolar-4.4',
        'canin-4.3',
        'incisiv-4.2',
        'incisiv-4.1',
        'incisiv-3.1',
        'incisiv-3.2',
        'canin-3.3',
        'premolar-3.4',
        'premolar-3.5',
        'molar-3.6',
        'molar-3.7',
        'molar-3.8'
      ]
    },
    dintiDestinatie: [],
    dintiTratamentCoroana: [],
    filterTratamente: undefined,
    punteSide: undefined,
    punteDirection: undefined,
    confirmationMsg: undefined,
    confirmationSubject: undefined,
    cloneHistory: undefined,
    programari: [],
    instrumenteSterilizate: [],
    reset_wapp_qr: false,
    qrRefreshKey: Date.now()
  },
  mutations: {
    SET_STATE ({ state }, { key, value }) {
      state[key] = value;
    },
    MARK_INSTRUMENTS_AS_STERILIZED (state, usedInstruments) {
      usedInstruments.forEach(instrument => {
        const index = state.instrumenteSterilizate.findIndex(obj => obj._id === instrument._id);
        if (index !== -1) {
          state.instrumenteSterilizate.splice(index, 1);
        }
      })
    },
    UPDATE_NOTA (state, data) {
      const history = state.pacient?.history;
      const index = history.findIndex(nota => nota.id === data.noteId);
      Vue.set(state.pacient.history[index], 'detalii', data.text);
      Vue.set(state.modalData, 'detalii', data.text);
    },
    'FILTER_TRATAMENTE_HISTORY' (state, { medic = '', dinte = '' }) {
      !state.cloneHistory && (state.cloneHistory = state.pacient.history.slice())
      const results =
        state.cloneHistory
          .filter(o => isEqualString(o.medic, medic) || isEqualString(o.dinte, dinte))
      Vue.set(state.pacient, 'history', results)
    },

    'CLEAR_FILTER_TRATAMENTE' (state) {
      if (state.cloneHistory) {
        Vue.set(state.pacient, 'history', state.cloneHistory)
        Vue.set(state, 'cloneHistory', undefined)
      }
    },

    'FILTER_JUDETE' (state) {
      state.judete = judete.map(obj => obj.nume)
    },

    'FILTER_ORASE_BY_JUDET' (state, judet) {
      const name = judet.name || judet
      state.orase =
        judete
          .filter(obj => obj.nume.toLowerCase() === name.toLowerCase())
          .map(obj => obj.localitati.map(o => o.nume))[0]
    },

    'FILTER_DINTI_ORIGINE' (state) {
      /* trebuie sa obtin in final un array cu dinti in format text,
      * care sa contina toti dintii mai putin cei implicati in punti,
      * cei stersi sau extrasi
      * 1. dintii care nu sunt implicati in punti > creaza o lista cu numele
      * in text al dintilor > extrage numele lor din state.dantura obj
      * */
      const punti =
        state.pacient.history
          .filter(obj => obj.denumire && obj.denumire.includes('punte'))
          .map(obj => {
            return {
              direction: obj.direction,
              side: obj.side,
              start: obj.start,
              end: obj.end
            }
          })

      const puntiArr =
        punti.reduce((a, c) => {
          if (c.direction === 'right') {
            while (c.start <= c.end) {
              a.push(state.dantura[c.side][c.start].replace('-', ' '))
              c.start++
            }
          }
          else {
            while (c.end <= c.start) {
              a.push(state.dantura[c.side][c.end].replace('-', ' '))
              c.end++
            }
          }
          return a
        }, [])

      const extractii = state.pacient.history
        .filter(obj => obj.mapID === 3)
        .map(obj => obj.dinte)

      const stersi = state.pacient.dintiStersi.map(val => val.replace('-', ' '))

      const toRemove = stersi.concat(puntiArr, extractii)

      state.dintiTratamentCoroana = _.difference(state.dinti, toRemove)
    },

    'SET_DINTI_DESTINATIE' (state, dinteOrigine) {
      /* arata doar dintii:
      * 1. de pe partea selectata de dintele origine
      * 2. care nu sunt stersi
      * 3. care nu sunt extrasi */

      /* determina partea danturii */
      for (let key in state.dantura) {
        state.dantura[key].includes(dinteOrigine) &&
        (state.punteSide = key)
      }

      const extractii =
        state.pacient.history
          .filter(obj => obj.mapID === 3)
          .map(obj => obj.dinte.replace(' ', '-'))

      const punti =
        state.pacient.history
          .filter(obj => obj.denumire && obj.denumire.includes('punte'))
          .map(obj => {
            return {
              direction: obj.direction,
              side: obj.side,
              start: obj.start,
              end: obj.end
            }
          })

      const puntiArr =
        punti.reduce((a, c) => {
          if (c.side === state.punteSide) {
            if (c.direction === 'right') {
              while (c.start <= c.end) {
                a.push(state.dantura[c.side][c.start])
                c.start++
              }
            }
            else {
              while (c.end <= c.start) {
                a.push(state.dantura[c.side][c.end])
                c.end++
              }
            }
          }
          return a
        }, [])

      const toRemove = extractii.concat(state.pacient.dintiStersi, puntiArr, [dinteOrigine])

      state.dintiDestinatie = _.difference(state.dantura[state.punteSide], toRemove)
    },

    'SET_PUNTE_DIRECTION' (state) {
      const start = state.dantura[state.punteSide].indexOf(state.modalData.dinte.replace(' ', '-'))
      const end = state.dantura[state.punteSide].indexOf(state.modalData.dinteDestinatie.replace(' ', '-'))
      const direction = start < end ? 'right' : 'left'
      Vue.set(state.modalData, 'dinteStart', state.modalData.dinte.replace(' ', '-'))
      Vue.set(state.modalData, 'start', start)
      Vue.set(state.modalData, 'end', end)
      Vue.set(state.modalData, 'side', state.punteSide)
      Vue.set(state.modalData, 'direction', direction)
      /* set punte fill color */
      const fill =
        state.tratamente
          .filter(obj => obj.name === state.modalData.denumire)
          .map(obj => obj.fill)[0]
      Vue.set(state.modalData, 'fill', fill)
    },

    'REMOVE_KEY_VALUE' (state, { sub, key }) {
      sub ? delete state[sub][key] : delete state[key]
    },

    'MAKE_AVATAR_PIC' (state, name) {
      state.avatarPic = `/history-imgs/${state.pacient._id}/${name}`
    },

    'FILTER_TRATAMENTE' (state) {
      state.ddClone = state.tratamente.slice()
      switch (state.filterTratamente) {
        case STRINGS.ADD_COROANA:
          state.tratamente = state.ddClone.filter(obj => obj.id < 2)
          break
        case STRINGS.EXTRACTIE:
          state.tratamente = state.ddClone.filter(obj => obj.id === 3)
          break
        case 'implant':
          state.tratamente = state.ddClone.filter(obj => obj.id === 4)
          break
        case 'tratament endodontic':
          state.tratamente = state.ddClone.filter(obj => obj.id > 5 && obj.id < 6)
          break
        default:
          break
      }
    },

    'SET_TRATAMENT' (state, name) {
      Vue.set(state.modalData, 'denumire', name)
      state.tratamente.forEach(obj => {
        obj.name === name &&
        Vue.set(state.modalData, 'mapID', obj.id)
      })
    },

    'ADD_IMG_INDEX' (state, {i1, i2, index}) {
      Vue.set(state.pacient.history[i1].pics[i2], 'index', index)
    },

    'ADD_IMGS_TO_MODAL' (state, { file, picName }) {
      const formatImgName = `${state.modalData.id}-${getRandom()}-${picName}`
      state.modalData.pics.push({
        name: formatImgName,
        w: undefined,
        h: undefined
      })
      state.formData.append(formatImgName, file)

      function getRandom () {
        return Math.floor(Math.random() * 100000)
      }
    },

    'REMOVE_IMG' (state, { picName }) {
      Vue.set(state.modalData, 'deleted', [])
      state.modalData.deleted.push(picName)
      let index = _.findIndex(state.modalData.pics, o => o.name === picName)
      state.modalData.pics.splice(index, 1)
      state.formData.delete(picName)
    },

    'SET_KEY_VALUE' (state, { key, sub, value }) {
      sub
        ? Vue.set(state[key], sub, value)
        : Vue.set(state, key, value)
    },

    'SET_MODULE_KEY_VALUE' (state, { key, module, value }) {
      Vue.set(state[module], key, value)
    },

    'SEARCH_DD' (state, { string, template }) {
      !state.ddClone &&
      (state.ddClone = state[template].slice())
      state[template] =
        state.ddClone
          .filter(val => template === 'tratamente' ? val.name.toLowerCase().indexOf(string) > -1 : val.toLowerCase().indexOf(string) > -1)
          .map(val => val)
    },

    SET_VALUE (state, { key, value, template, clone }) {
      template && state.ddClone && (state[template] = state.ddClone.slice())
      state[key] = value
    },

    RESET_DD_CLONE (state, { template }) {
      state.ddClone && (state[template] = state.ddClone.slice())
      state.ddClone = undefined
    },
    SET_MODAL (state, { val, name, setValues }) {
      Vue.set(state, 'isSemnaturaActiva', false);

      // ✅ hard reset so old keys (like detalii) never leak
      const base = {
        type: undefined,
        createdAt: new Date(),
        pics: []
      };

      // replace the whole object for a clean slate
      Vue.set(state, 'modalData', base);

      // now apply the new payload
      if (setValues) {
        Object.keys(setValues).forEach(key => {
          Vue.set(state.modalData, key, setValues[key]);
        });
      }

      Vue.set(state.modalData, 'signature', state.pacient.signature);
      state.modalComponentName = name;
      state.isModal = val;
    },
    TOGGLE_MODAL (state, value) {
      state.isModal = value;
    },
    RESET_MODAL_DATA (state) {
      state.modalData = {
        type: undefined,
        createdAt: new Date(),
        pics: []
      }
      state.formData = new FormData()
      state.isUpdateModal = false
    },
    ARRANGE_TRATAMENT_PICS_ARRAY (state) {
      const arr = []
      state.modalData.type === 'tratament' &&
      ['inainte', 'dupa'].forEach(val => {
        state.modalData.pics.forEach(obj => {
          obj.name.includes(val) && arr.push(obj)
        })
      })
      Vue.set(state.modalData, 'pics', arr)
    },
    UPDATE_HISTORY (state, data) {
      state.pacient.history.forEach((obj, index) => {
        if (obj.id === data.id) {
          Vue.set(state.pacient.history, index, data);
        }
      });
    },
    ADD_APPOINTMENT_TO_PATIENT (state, appointment) {
      state.pacient.icalendar.push(appointment);
    },
    UPDATE_APPOINTMENT_IN_PATIENT (state, appointment) {
      const index = state.pacient.icalendar.findIndex(obj => obj._id === appointment._id);
      Vue.set(state.pacient.icalendar, index, appointment);
    },
    DELETE_APPOINTMENT_IN_PATIENT (state, appointment) {
      const index = state.pacient.icalendar.findIndex(obj => obj._id === appointment._id);
      state.pacient.icalendar.splice(index, 1);
    },
    UPDATE_HISTORY_NOTE (state, note) {
      // return if note.patient_id is different then state.pacient._id
      const index = state.pacient.history.findIndex(obj => obj.type === 'nota' && note.id?.toString() === obj.id?.toString());
      console.log({index}, state.pacient.history)
      index > -1
        ? Vue.set(state.pacient.history, index, note)
        : state.pacient.history.unshift(note);
    },
    UPDATE_HISTORY_NOTE_DETALII (state, note) {
      const index = state.pacient.history.findIndex(obj => obj.type === 'nota' && note.id?.toString() === obj.id?.toString());
      index > -1 && Vue.set(state.pacient.history[index], 'detalii', note.detalii);
    },
    DELETE_NOTE_FROM_HISTORY (state, note_id) {
      const index = state.pacient.history.findIndex(obj => obj.type === 'nota' && note_id?.toString() === obj.id?.toString());
      index > -1 && state.pacient.history.splice(index, 1);
    },
    RESET_WAPP_QR(state, payload) {
      const { value } = payload;

      const allowedEmails = [
        'florian_ozana@yahoo.com',
        'denisa_parjol@ymail.com'
      ];

      if (!allowedEmails.includes(state.user.email)) return;

      state.reset_wapp_qr = value;

      if (value === true) {
        state.qrRefreshKey = Date.now();
      }
    }

  },
  actions: {
    async set_signature ({state, commit}, ids) {
      try {
        const url = '/api/signature'
        await axios.post(url, ids)
        Vue.set(state, 'isSemnaturaActiva', true)
      } catch (e) {
        window.alert('Eroare activare semnatura digitala.')
      }
    },
    async block_pacient ({ rootState, state }) {
      try {
        Vue.set(state, 'isLoading', true);
        const { data } = await axios.post('/api/block-pacient', { id: state.pacient._id });
        rootState.pacientiModule.pacienti.forEach((obj, idx) => {
          if (obj._id === state.pacient._id) {
            obj.blocked = !obj.blocked;
            Vue.set(rootState.pacientiModule.pacienti, idx, obj)
          }
        })
        Vue.set(state, 'blockPacient', data.blocked)
        Vue.set(state, 'pacient', data);
        Vue.set(state, 'isLoading', false);
      }
      catch (e) {
        Vue.set(state, 'isLoading', false)
        console.log(`cannot block pacient`, e)
      }
    },
    save_punte ({ state }, { side, start, end, direction, fill, denumire, clbk = () => {} }) {
      save()

      async function save () {
        try {
          state.isLoading = true
          const payload = {
            type: 'tratament',
            denumire: state.modalData.denumire || denumire,
            createdAt: new Date(),
            id: new Date().getTime(),
            side,
            dinte: state.dantura[side][start],
            dinteStart: state.dantura[side][start],
            dinteDestinatie: state.dantura[side][end],
            start,
            end,
            direction,
            fill
          }
          const { data } = await axios.post(`/api/save-punte/${router.currentRoute.params.id}`, payload)
          clbk()
          state.isLoading = false
          state.pacient.history.unshift(payload)
          state.modalData.dinte = undefined
        } catch (e) {
          console.log(e.response.data)
        }
      }
    },
    delete_punte ({ state, commit }) {
      deletePunte()

      async function deletePunte () {
        try {
          const id = router.currentRoute.params.id
          const idPunte = state.modalData.id
          const { data } = await axios(`/api/delete-punte/${id}/${idPunte}`)
          state.pacient.history = data
          state.isModal = false
          commit('RESET_MODAL_DATA')
        } catch (e) {
          console.log(e.response.data)
        }
      }
      state.isModal = false
      commit('RESET_MODAL_DATA')
    },
    save_scrisoare ({ state, commit }) {
      save()

      async function save () {
        try {
          const { data } = await axios.post(`/api/save-scrisoare`, {
            id: router.currentRoute.params.id,
            text: state.textScrisoare
          })
          commit('SET_MODAL', {
            name: undefined,
            val: false
          })
          state.pacient = data
          window.print()
        } catch (e) {
          console.log(e)
        }
      }
    },
    delete_avatar ({ state, commit }) {
      state.isLoading = true
      delImg()

      async function delImg () {
        try {
          const id = state.pacient._id
          const index = state.avatarPic.indexOf('avatar')
          const name = state.avatarPic.substr(index, state.avatarPic.length)
          const { data } = await axios.post('/api/delete-avatar-img', { id, name })
          state.avatarPic = undefined
          commit('SET_MODAL', {
            name: undefined,
            val: false
          })
          caches.open('v1').then(function(cache) {
            cache.delete(`/history-imgs/${id}/avatar.png`)
              .then(function(response) {
                // img removed from cache
              })
          })
          state.isLoading = false
        } catch (e) {
          state.isLoading = false
          console.log(e.response.data)
        }
      }
    },
    upload_avatar ({ state, commit }, file) {
      state.isLoading = true
      saveImg()

      async function saveImg () {
        try {
          const { data } = await axios.post('/api/save-avatar-img', file)
          commit('MAKE_AVATAR_PIC', data)
          state.isLoading = false
        } catch (e) {
          state.isLoading = false
          window.alert('Eroare server.')
        }
      }
    },
    delete_tratament ({ state, commit }, { id }) {
      state.isLoading = true
      sterge()

      async function sterge () {
        try {
          const { data } = await axios.post(`/api/sterge-tratament/${id}`, state.modalData)
          state.pacient.history.slice().forEach((obj, i) => {
            obj.id === data.id && state.pacient.history.splice(i, 1)
          })
          state.isModal = false
          commit('RESET_MODAL_DATA')
          state.isLoading = false
        } catch (e) {
          console.log(e)
          window.alert('Eroare server, va rugam contactati web master.')
        }
      }
    },
    sterge_dinte ({ state }, { dinte, clbk }) {
      sterge()

      async function sterge () {
        try {
          const { data } = await axios.post(`/api/sterge-dinte/${router.currentRoute.params.id}`, { dinte })
          if (!state.pacient.dintiStersi) {
            Vue.set(state.pacient, 'dintiStersi', [])
          }
          let index = state.pacient.dintiStersi.indexOf(dinte)
          index > -1 ? state.pacient.dintiStersi.splice(index, 1) : state.pacient.dintiStersi.push(dinte)
          clbk && clbk()
        } catch (e) {
          console.log(e)
          console.log(`dintele nu a fost sters`)
        }
      }
    },
    delete_user ({ state, dispatch }) {
      state.isLoading = true
      axios(`/api/delete-user/${state.modalData.email}/${state.modalData._id}`)
        .then(({ data }) => {
          state.isLoading = false
          state.isModal = false
          state.utilizatori.forEach((obj, index) => {
            obj._id === data.id && state.utilizatori.splice(index, 1)
          })
          dispatch('get_utilizatori')
        })
        .catch(e => {
          console.log(e.response ? e.response.data : e)
        })
    },
    update_doc_history ({ state, commit }, { id }) {
      state.formData.append('obj', JSON.stringify(state.modalData))
      state.isLoading = true
      update()
      async function update () {
        try {
          const { data } = await axios.post(`/api/update-doc/${id}`, state.formData)
          state.pacient.history.forEach((obj, index) => {
            if (obj.id === data.id) {
              Vue.set(state.pacient.history, index, data)
            }
          })
          state.isModal = false
          commit('RESET_MODAL_DATA')
          state.isLoading = false
        } catch (e) {
          console.log(e)
        }
      }
    },
    save_utilizator ({ state, dispatch, commit }) {
      state.isLoading = true
      delete state.modalData.createdAt
      delete state.modalData.pics
      save()
      async function save () {
        try {
          const { data } = await axios.post(`/api/save-utilizator`, state.modalData)
          state.utilizatori.unshift(data)
          state.isModal = false
          state.isLoading = false
          state.isExistingUser = undefined
          commit('RESET_MODAL_DATA')
          dispatch('get_utilizatori')
        } catch (e) {
          state.isLoading = false
          const status =  e.response.status
          if (status === 409) state.isExistingUser = true
        }
      }
    },
    update_utilizator ({ state, commit }) {
      state.isLoading = true
      const id = state.modalData._id
      delete state.modalData.id
      update()
      async function update () {
        try {
          const { data } = await axios.post(`/api/update-utilizator/${id}`, state.modalData)
          state.utilizatori.forEach((obj, index) => {
            if (obj._id === id) {
              Vue.set(state.utilizatori, index, data)
            }
          })
          state.isModal = false
          state.isLoading = false
          commit('RESET_MODAL_DATA')
        } catch (e) {
          console.log(e)
        }
      }
    },
    async save_history ({ state, commit }, { id, isAutoSave, usedInstruments = [] }) {
      if (usedInstruments.length) {
        state.modalData.sterilizari = [ ...state.modalData.sterilizari || [], ...usedInstruments];
        state.formData.append('usedInstruments', JSON.stringify(usedInstruments));
      }
      state.modalData.id = new Date().getTime();
      state.modalData.type === 'tratament' && commit('ARRANGE_TRATAMENT_PICS_ARRAY');
      state.formData.append('obj', JSON.stringify(state.modalData));
      state.isLoading = true;
      try {
        // return
        const { data } = await axios.post(`/api/save-history/${id}`, state.formData);
        !state.pacient.history && Vue.set(state.pacient, 'history', []);
        /* receive the history array from the server, and update it */
        state.pacient = data;
        state.isModal = isAutoSave;
        commit('RESET_MODAL_DATA');
        state.isLoading = false;
        // remove any usedInstruments from the state
        usedInstruments.length && commit('MARK_INSTRUMENTS_AS_STERILIZED', usedInstruments);
      }
      catch (e) {
        console.log(e)
      }
    },
    async update_history ({ state, commit, dispatch }, { id, isAutoSave, usedInstruments = [] }) {
      if (state.modalData.type === 'tratament') {
        commit('ARRANGE_TRATAMENT_PICS_ARRAY')
        // add used instruments to be marked as used on the server
        if (usedInstruments.length) {
          state.modalData.sterilizari = [ ...state.modalData.sterilizari || [], ...usedInstruments];
          state.formData.append('usedInstruments', JSON.stringify(usedInstruments));
        }
      }
      state.modalData.updated_at = new Date().toISOString();
      state.formData.append('obj', JSON.stringify(state.modalData));
      if (!isAutoSave) {
        state.isLoading = true;
      }
      try {
        const { data } = await axios.post(`/api/update-history/${id}`, state.formData)
        commit('UPDATE_HISTORY', data);
        data.signature && Vue.set(state.pacient, 'signature', data.signature);
        state.isModal = isAutoSave;
        !isAutoSave && commit('RESET_MODAL_DATA');
        state.isLoading = false;
        state.formData.delete('obj');
        // we delete stored data because we've saved the note
        // if (!isAutoSave) {
        //   localStorage.removeItem('noteModalOpen');
        //   localStorage.removeItem('noteId');
        // }
        // fetch again the unused instruments list from the server
        const { data: instruments } = await axios.get(`/api/instrumente-sterilizate`);
        Vue.set(state, 'instrumenteSterilizate', instruments);
      }
      catch (err) {
        console.log(`err update_history`, err)
      }
    },
    async update_note ({commit}) {
      try {
        // const { data } = await axios.get(api.)
      } catch (err) {
        console.log(err)
      }
    },
    async get_patient ({ state, commit }, { id, clbk }) {
      try {
        Vue.set(state, 'isLoading', true)
        const { data } = await axios(`/api/get-pacient/${id}`);
        const { data: instruments } = await axios(`/api/instrumente-sterilizate`);
        Vue.set(state, 'pacient', data);
        Vue.set(state, 'instrumenteSterilizate', instruments);

        commit('SET_WAPP_FEEDBACK_STATE', data.send_feedback_after_treatment);

        /* get avatar pic */
        data._attachments &&
        Object.keys(data._attachments)
          .forEach(key => {
            key.indexOf('avatar') > -1 && commit('MAKE_AVATAR_PIC', key)
          })
        state.antecedente =
          Object.keys(data.antecedente)
            .filter(key => key !== 'alergii')
            .some(key => data.antecedente[key].val)
        state.alergii =
          Object.keys(data.antecedente)
            .filter(key => key === 'alergii')
            .some(key => data.antecedente[key].val)
        Vue.set(state, 'programari', data.programari ? data.programari.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()) : [])
        clbk && clbk(data)
        Vue.set(state, 'isLoading', false)
      }
      catch (e) {
        Vue.set(state, 'isLoading', false)
        console.log(`get pacient err`, e)
      }
    },
    // async mark_history ({state, commit}, payload) {
    //   try {
    //     Vue.set(state, 'isLoading', true)
    //     const { data } = await axios.post(api.markHistory, payload);
    //     Vue.set(state, 'modalData', { ...state.modalData, ...data });
    //     Vue.set(state, 'isLoading', false);
    //     if (!payload.is_open_by) {
    //       localStorage.removeItem('noteModalOpen');
    //       localStorage.removeItem('noteId');
    //     }
    //   } catch (err) {
    //     Vue.set(state, 'isLoading', false)
    //     console.log(err)
    //   }
    // },
    get_utilizatori ({ state }, direction) {
      getUtilizatori()
      async function getUtilizatori () {
        try {
          if (direction) {
            direction === 'next' ? state.page++ : state.page--
          }
          const { data } = await axios.post('/api/get-utilizatori', { page: state.page })
          state.lastPage = !data.isNextPage
          state.utilizatori = data.utilizatori
        } catch (e) {
          console.log(`get patients error`)
        }
      }
    },
    /* todo de sters la urmatoarea revizie */
    save_pacient ({ rootState, state }, payload) {
      state.isLoading = true
      /* in case the date has changed, we reupdate the birthdate */
      payload.birthdate = payload.date
      delete payload.date
      payload.telefon = payload.telefon.replace(/ /g, '')
      payload.id ? update() : save()
      async function save () {
        payload.createdAt = Date.now()
        try {
          const { data } = await axios.post('/api/save-pacient', payload);
          const pacienti = [data, ...rootState.pacientiModule.pacienti];
          Vue.set(rootState.pacientiModule, 'pacienti', pacienti);
          state.isLoading = false;
          await router.push('/pacienti');
        } catch (err) {
          state.isLoading = false
          console.log('err', err);
        }
      }
      async function update () {
        try {
          const { data } = await axios.post(`/api/update-pacient/${router.currentRoute.params.id}`, payload);
          let pacientId;
          rootState.pacientiModule.pacienti.forEach((o, idx) => {
            +o.id === +payload.id && (pacientId = idx)
          });
          // sterge pacientul editat din matrice
          rootState.pacientiModule.pacienti.splice(pacientId, 1);
          rootState.pacientiModule.pacienti.unshift(data);
          state.isLoading = false
          await router.push('/pacienti')
        } catch (e) {
          state.isLoading = true
          console.log('err')
        }
      }
    },
    delete_pacient ({ state }) {
      state.isLoading = true
      del()

      async function del () {
        try {
          const { data } = await axios(`/api/delete-pacient/${router.currentRoute.params.id}`)
          state.isLoading = false
          state.isModal = false
          data && router.push('/pacienti')
        } catch (e) {
          console.log(e.response.data)
        }
      }
    },
    async get_medici ({ state }) {
      try {
        const { data } = await axios('/api/get-medici')
        Vue.set(state, 'medici', data)
      } catch (e) {
        console.log(e)
      }
    },
    async save_programare ({ state }) {
      try {
        Vue.set(state, 'isLoading', true)
        const { data } = await axios.post(`/api/save-programare/${router.currentRoute.params.id}`, state.modalProgramare)
        Vue.set(state, 'programari', data.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()))
        Vue.set(state.pacient, 'programari', data)
        Vue.set(state, 'isLoading', false)
        Vue.set(state, 'isModal', false)
        Vue.set(state, 'modalComponentName', undefined)
      }
      catch (e) {
        Vue.set(state, 'isLoading', false)
        console.log(`eroare save_programare`, checkObjProps(e, 'response.data'))
      }
    },
    async update_programare ({ state }) {
      try {
        Vue.set(state, 'isLoading', true)
        const { data } = await axios.put(`/api/update-programare/${router.currentRoute.params.id}`, state.modalProgramare)
        Vue.set(state, 'programari', data)
        Vue.set(state, 'isLoading', false)
        Vue.set(state, 'isModal', false)
        Vue.set(state, 'modalComponentName', undefined)
      }
      catch (e) {
        Vue.set(state, 'isLoading', false)
        console.log(`eroare save_programare`, checkObjProps(e, 'response.data'))
      }
    },
    async delete_programare ({ state }) {
      try {
        Vue.set(state, 'isLoading', true)
        const { data } = await axios.post(`/api/sterge-programare/${router.currentRoute.params.id}`, state.modalProgramare)
        Vue.set(state, 'programari', data)
        Vue.set(state, 'isLoading', false)
        Vue.set(state, 'isModal', false)
        Vue.set(state, 'modalComponentName', undefined)
      }
      catch (e) {
        Vue.set(state, 'isLoading', false)
        console.log(`eroare save_programare`, checkObjProps(e, 'response.data'))
      }
    }
  },
  getters: {
    tratament: state => {
      let tratament
      state.pacient.history.forEach(obj => {
        !tratament &&
        (obj.dinte && obj.dinte.replace(' ', '-')) === state.modalData.dinteStart &&
        (tratament = obj.denumire)
      })
      return tratament
    }
  },
  modules: {
    login,
    pacientModule,
    pacientiModule,
    reviews,
    sterilizare,
    calendar,
    note,
    statistics,
  }
});

// Connect to SSE endpoint
const eventSource = new EventSource('/api/events');

// Listen for messages
eventSource.onmessage = (event) => {
  const data = JSON.parse(event.data);
  console.log('Received:', data);
};

// Listen for SSE notify events
eventSource.addEventListener('events-notify', (event) => {
  const data = JSON.parse(event.data);
  switch (data.msg) {
    case 'reset_wapp_qr':
      store.commit('RESET_WAPP_QR', { key: 'reset_wapp_qr', value: true });
      break
    case 'wapp_ready':
      store.commit('RESET_WAPP_QR', { key: 'reset_wapp_qr', value: false });
      break
  }
});

// Listen for specific event types
eventSource.addEventListener('new-note', (event) => {
  const data = JSON.parse(event.data);
  store.commit('UPDATE_HISTORY_NOTE', data);
});

// Listen for specific event types
eventSource.addEventListener('note-updated', (event) => {
  const data = JSON.parse(event.data);
  // console.log(data)
  // store.commit('UPDATE_NOTE_DETALII_BY_ID', data);
  store.commit('UPDATE_HISTORY_NOTE_DETALII', data);
});

// Handle connection events
eventSource.onopen = () => {
  console.log('SSE connection opened');
};

eventSource.onerror = (error) => {
  console.error('SSE error:', error);
};

export default store;

/*
  // Connect to SSE endpoint
const eventSource = new EventSource('/api/events');

// Listen for messages
eventSource.onmessage = (event) => {
  const data = JSON.parse(event.data);
  console.log('Received:', data);
};

// Listen for specific event types
eventSource.addEventListener('note-updated', (event) => {
  const data = JSON.parse(event.data);
  store.commit('UPDATE_NOTA', data);
});

// Handle connection events
eventSource.onopen = () => {
  console.log('SSE connection opened');
};

eventSource.onerror = (error) => {
  console.error('SSE error:', error);
};
*/
